import { FC } from 'react';
import { useTranslation } from 'next-i18next';

import { humanizeDuration } from '@phoenix/team-m/dashboard/frontend/shared/humanize';
import { productCategoryAndDriveType } from '@phoenix/team-m/my-tool-shed/frontend/util/master-data';
import { ProductCategory, ProductDriveType } from '@phoenix/team-m/dashboard/frontend/util/product/product.model';

export const ProductDetails: FC<{
  name: string;
  articleNumber: string;
  category?: ProductCategory;
  driveType?: ProductDriveType;
  runtime?: number | null;
}> = ({ name, articleNumber, category, driveType, runtime }) => {
  const { t } = useTranslation();

  return (
    <div className="h-[7.2rem]">
      <p className="mt-2 truncate stihl-text-body-default-reg">
        {productCategoryAndDriveType({ productCategory: category, productDriveType: driveType })}
      </p>
      <p className="mt-2 line-clamp-1 stihl-text-body-default-bold">{name}</p>
      <p className="mt-2 stihl-text-body-default-reg">{articleNumber}</p>
      {runtime && runtime > 0 ? (
        <div className="mt-2 space-x-4">
          <span className="stihl-text-body-default-reg">{t('dashboard_compatibleProducts_card_value_runtime')}</span>
          <span className="stihl-text-body-default-bold">{humanizeDuration(runtime)}</span>
        </div>
      ) : null}
    </div>
  );
};
